var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
class EventTerminal {
  constructor(incomingEvents) {
    __publicField(this, "eventListeners", {});
    __publicField(this, "incomingEventListeners", {});
    this.initWindowListeners(incomingEvents);
  }
  handleEvent(eventName, rawEvent) {
    var _a;
    const event = rawEvent;
    (_a = this.eventListeners[eventName]) == null ? void 0 : _a.forEach((callback) => callback(event.detail));
  }
  initWindowListeners(incomingEvents) {
    Object.values(incomingEvents).forEach((rawEventName) => {
      const eventName = rawEventName;
      const eventHandler = this.handleEvent.bind(this, eventName);
      window.addEventListener(eventName, eventHandler);
      this.incomingEventListeners[eventName] = eventHandler;
    });
  }
  addEventListener(eventName, listener) {
    if (!this.eventListeners[eventName]) this.eventListeners[eventName] = [];
    this.eventListeners[eventName].push(listener);
  }
  removeEventListener(eventName, listener) {
    if (!this.eventListeners[eventName]) return;
    const handlerIndex = this.eventListeners[eventName].indexOf(listener);
    if (handlerIndex === -1) return;
    this.eventListeners[eventName].splice(handlerIndex, 1);
  }
  emit(name, detail) {
    window.dispatchEvent(new CustomEvent(name.toString(), { detail }));
  }
  close() {
    Object.entries(this.incomingEventListeners).forEach(([eventName, eventHandler]) => {
      window.removeEventListener(eventName, eventHandler);
    });
  }
}
export {
  EventTerminal
};
